import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
	constructor() {
		
	}
}


// WEBPACK FOOTER //
// ./src/app/bondmath/globals.ts